import { render, staticRenderFns } from "./workflowfunctionalapproval.vue?vue&type=template&id=04cb9b36"
import script from "./workflowfunctionalapproval.vue?vue&type=script&lang=js"
export * from "./workflowfunctionalapproval.vue?vue&type=script&lang=js"
import style0 from "./workflowfunctionalapproval.vue?vue&type=style&index=0&id=04cb9b36&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports